// extracted by mini-css-extract-plugin
module.exports = {"buttons":"profile-form_buttons__2L2R5"};